import React, { useContext } from 'react'
import { useState } from 'react';
import { useEffect } from 'react'
import ContentService from "../../services/ContentService"
import "./Contents.css"
import { Container, Row } from 'reactstrap';
import PageTitle from "../pagetitle/PageTitle";
import { Link } from 'react-router-dom';
import Loading from '../loading/Loading';
import AppContext from "../../context/AppContext";

function Contents({ adet = 3, baslik }) {
  const [contents, setContents] = useState([])
  const { mainPageNews } = useContext(AppContext);
  useEffect(() => {
    setContents(mainPageNews?.slice(0, adet));
  })


  return (
    <>
      <Loading />
      <Container className='mt-4'>
        <div className='homeTitle'>HABERLER</div>
        <div className="row">
              <div className="newsBox">
                <div className="row">
                  {
                    contents?.map((content, index) => (
                      <div className="col-md-4 news">
                        <Link to={`/content/${content?.uri}`}>
                          <div className="pcture"><img src={`https://content.samsun.edu.tr${content?.coverImageUrl}`}></img></div>
                          <div className="detail">
                            <span className="time"><i className="bi bi-calendar-check"></i>
                              {new Date(content?.atCreatedDate).toLocaleDateString("tr-TR")}
                            </span>
                            <span className="title">{content?.title}</span>
                            <span className="url">
                              Devamını oku<i className="bi bi-chevron-right"></i>
                            </span>
                          </div>
                        </Link>
                      </div>
                    ))
                  }
                </div>


                {(() => {
                  if (baslik) {
                    return (
                      <div class="tumu">
                        <Link to="/haberler">Tüm haberler</Link>
                      </div>
                    )
                  }
                })()}
              </div>
        </div>
      </Container>
    </>
  )
}

export default Contents;
